import { put, call, takeEvery } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import {
  ACCEPT_LESSON,
  ACCEPT_LESSON_FAIL,
  ACCEPT_LESSON_SUCCESS,
  AcceptLessonActionType
} from '../redux/lessonsReducer'
import { Lesson } from '../types'

function* AcceptLessonFlow(action: AcceptLessonActionType): Generator<any, void, any> {
  try {
    const response: Lesson = yield call(apiCall, {
      endpoint: `/tutors/lessons/${action.payload.lessonId}/approve`,
      method: 'PUT',
      params: {}
    })
    yield put(ACCEPT_LESSON_SUCCESS(response))
  } catch (error) {
    yield put(ACCEPT_LESSON_FAIL())
    console.log(error)
  }
}

export default function* AcceptLessonSaga(): Generator<any, void, any> {
  yield takeEvery([ACCEPT_LESSON], AcceptLessonFlow)
}
